export default __webpack_public_path__ + "img/b0a0e607afdb0e17db4d9209d427468d.svg";